import React, { useState } from 'react'

const TestimonialsNew = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const [isPaused, setIsPaused] = useState(false);


    const testimonials = [
        {
            text: "What I appreciate most about the app this app is the convenience; no stress user friendly interface, easy and convenient, it can hold up multiple currencies, highly recommend for anyone who wants to either stay on top of theirs finances and build a great savings habit.",
            name: "Moses John",
            img: "/images/moses_john.png",
        },
        {
            text: "Afripay is a great app, if you're thinking of traveling,  get the app",
            name: "Oludamola Ogidan",
            img: "/images/oludamola_ogidan.png",
        },
        {
            text: "I love using Afripay! It's super easy to send and receive money, and the transactions are always quick. The app is user-friendly, and I appreciate the different payment options. Keep up the good work!",
            name: "Ruth HY",
            img: "/images/ruth_hy.png",
        },
    ];

    React.useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const cardsToShow = isMobile ? 1 : 2;
    const maxIndex = testimonials.length - cardsToShow;
    const totalIndicators = maxIndex + 1;

    React.useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => {
                if (prevIndex < maxIndex) {
                    return prevIndex + 1;
                } else {
                    return 0;
                }
            });
        }, 4000);

        return () => clearInterval(interval);
    }, [isPaused, maxIndex]);

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleNext = () => {
        if (currentIndex < maxIndex) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === maxIndex;

    return (
        <div className='max-w-7xl mx-auto flex flex-col items-start pt-6 md:pt-8 pb-6 md:pb-8 px-4'>
            <div className="w-full flex items-center justify-between mb-5">
                <div>
                    <h2 className="font-display-fran font-semibold text-[#030319] text-[22px] md:text-3xl leading-[1.1] tracking-[-0.02em] mb-1">
                        Real stories, Real impact
                    </h2>
                    <p className="text-[#344054] text-[13px] md:text-sm">Our customer story</p>
                </div>
                {/* Slider Left & Right Arrow Buttons - Desktop */}
                <div className="md:flex items-center gap-3 hidden">
                    <button
                        onClick={handlePrevious}
                        disabled={isFirstSlide}
                        className={`rounded-full p-2 transition-all ${isFirstSlide
                            ? 'bg-gray-300 opacity-50 cursor-not-allowed'
                            : 'bg-[#209D5A] hover:bg-[#1a8449]'
                            }`}
                    >
                        <svg
                            width={20}
                            height={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.46934 12.5301C3.32889 12.3895 3.25 12.1988 3.25 12.0001C3.25 11.8013 3.32889 11.6107 3.46934 11.4701L9.46934 5.47009C9.538 5.3964 9.6208 5.3373 9.7128 5.29631C9.8048 5.25532 9.90412 5.23328 10.0048 5.2315C10.1055 5.22972 10.2056 5.24825 10.2989 5.28597C10.3923 5.32369 10.4772 5.37983 10.5484 5.45105C10.6196 5.52227 10.6757 5.60711 10.7135 5.70049C10.7512 5.79388 10.7697 5.89391 10.7679 5.99461C10.7662 6.09532 10.7441 6.19463 10.7031 6.28663C10.6621 6.37863 10.603 6.46143 10.5293 6.53009L5.80934 11.2501L19.9993 11.2501C20.1983 11.2501 20.389 11.3291 20.5297 11.4698C20.6703 11.6104 20.7493 11.8012 20.7493 12.0001C20.7493 12.199 20.6703 12.3898 20.5297 12.5304C20.389 12.6711 20.1983 12.7501 19.9993 12.7501L5.80934 12.7501L10.5293 17.4701C10.603 17.5388 10.6621 17.6216 10.7031 17.7136C10.7441 17.8056 10.7662 17.9049 10.7679 18.0056C10.7697 18.1063 10.7512 18.2063 10.7135 18.2997C10.6757 18.3931 10.6196 18.4779 10.5484 18.5491C10.4772 18.6203 10.3923 18.6765 10.2989 18.7142C10.2056 18.7519 10.1055 18.7705 10.0048 18.7687C9.90412 18.7669 9.8048 18.7449 9.7128 18.7039C9.6208 18.6629 9.538 18.6038 9.46934 18.5301L3.46934 12.5301Z"
                                fill="white"
                            />
                        </svg>
                    </button>

                    <button
                        onClick={handleNext}
                        disabled={isLastSlide}
                        className={`rounded-full p-2 transition-all ${isLastSlide
                            ? 'bg-gray-300 opacity-50 cursor-not-allowed'
                            : 'bg-[#209D5A] hover:bg-[#1a8449]'
                            }`}
                    >
                        <svg
                            width={20}
                            height={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M20.5307 11.4699C20.6711 11.6105 20.75 11.8012 20.75 11.9999C20.75 12.1987 20.6711 12.3893 20.5307 12.5299L14.5307 18.5299C14.462 18.6036 14.3792 18.6627 14.2872 18.7037C14.1952 18.7447 14.0959 18.7667 13.9952 18.7685C13.8945 18.7703 13.7945 18.7518 13.7011 18.714C13.6077 18.6763 13.5228 18.6202 13.4516 18.5489C13.3804 18.4777 13.3243 18.3929 13.2865 18.2995C13.2488 18.2061 13.2303 18.1061 13.2321 18.0054C13.2338 17.9047 13.2559 17.8054 13.2969 17.7134C13.3379 17.6214 13.397 17.5386 13.4707 17.4699L18.1907 12.7499L4.00066 12.7499C3.80175 12.7499 3.61098 12.6709 3.47033 12.5302C3.32968 12.3896 3.25066 12.1988 3.25066 11.9999C3.25066 11.801 3.32968 11.6102 3.47033 11.4696C3.61098 11.3289 3.80175 11.2499 4.00066 11.2499L18.1907 11.2499L13.4707 6.52991C13.397 6.46125 13.3379 6.37845 13.2969 6.28645C13.2559 6.19445 13.2338 6.09514 13.2321 5.99443C13.2303 5.89373 13.2488 5.7937 13.2865 5.70031C13.3243 5.60692 13.3804 5.52209 13.4516 5.45087C13.5228 5.37965 13.6077 5.32351 13.7011 5.28579C13.7945 5.24807 13.8945 5.22954 13.9952 5.23132C14.0959 5.2331 14.1952 5.25514 14.2872 5.29613C14.3792 5.33712 14.462 5.39622 14.5307 5.46991L20.5307 11.4699Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Testimonials Container */}
            <div className='w-full overflow-hidden' onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
                <div
                    className='flex items-center gap-6 transition-transform duration-700 ease-in-out'
                    style={{
                        transform: `translateX(-${currentIndex * (100 / cardsToShow + 3)}%)`
                    }}
                >
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard key={index} testimonial={testimonial} />
                    ))}
                </div>
            </div>

            {/* Slider Indicators */}
            <div className='w-full flex items-center justify-between md:justify-center py-4 md:py-5'>
                <button
                    onClick={handlePrevious}
                    disabled={isFirstSlide}
                    className={`rounded-full p-4 block md:hidden transition-all ${isFirstSlide
                        ? 'bg-gray-300 opacity-50 cursor-not-allowed'
                        : 'bg-[#209D5A]'
                        }`}
                >
                    <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.46934 12.5301C3.32889 12.3895 3.25 12.1988 3.25 12.0001C3.25 11.8013 3.32889 11.6107 3.46934 11.4701L9.46934 5.47009C9.538 5.3964 9.6208 5.3373 9.7128 5.29631C9.8048 5.25532 9.90412 5.23328 10.0048 5.2315C10.1055 5.22972 10.2056 5.24825 10.2989 5.28597C10.3923 5.32369 10.4772 5.37983 10.5484 5.45105C10.6196 5.52227 10.6757 5.60711 10.7135 5.70049C10.7512 5.79388 10.7697 5.89391 10.7679 5.99461C10.7662 6.09532 10.7441 6.19463 10.7031 6.28663C10.6621 6.37863 10.603 6.46143 10.5293 6.53009L5.80934 11.2501L19.9993 11.2501C20.1983 11.2501 20.389 11.3291 20.5297 11.4698C20.6703 11.6104 20.7493 11.8012 20.7493 12.0001C20.7493 12.199 20.6703 12.3898 20.5297 12.5304C20.389 12.6711 20.1983 12.7501 19.9993 12.7501L5.80934 12.7501L10.5293 17.4701C10.603 17.5388 10.6621 17.6216 10.7031 17.7136C10.7441 17.8056 10.7662 17.9049 10.7679 18.0056C10.7697 18.1063 10.7512 18.2063 10.7135 18.2997C10.6757 18.3931 10.6196 18.4779 10.5484 18.5491C10.4772 18.6203 10.3923 18.6765 10.2989 18.7142C10.2056 18.7519 10.1055 18.7705 10.0048 18.7687C9.90412 18.7669 9.8048 18.7449 9.7128 18.7039C9.6208 18.6629 9.538 18.6038 9.46934 18.5301L3.46934 12.5301Z"
                            fill="white"
                        />
                    </svg>
                </button>

                <div className='flex items-center gap-2'>
                    {Array.from({ length: totalIndicators }).map((_, index) => (
                        <div
                            key={index}
                            className={`rounded-full transition-all ${index === currentIndex
                                ? 'w-4 h-4 bg-[#209D5A]'
                                : 'w-2.5 h-2.5 bg-[#EBEBEB]'
                                }`}
                        />
                    ))}
                </div>

                <button
                    onClick={handleNext}
                    disabled={isLastSlide}
                    className={`rounded-full p-4 block md:hidden transition-all ${isLastSlide
                        ? 'bg-gray-300 opacity-50 cursor-not-allowed'
                        : 'bg-[#209D5A]'
                        }`}
                >
                    <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M20.5307 11.4699C20.6711 11.6105 20.75 11.8012 20.75 11.9999C20.75 12.1987 20.6711 12.3893 20.5307 12.5299L14.5307 18.5299C14.462 18.6036 14.3792 18.6627 14.2872 18.7037C14.1952 18.7447 14.0959 18.7667 13.9952 18.7685C13.8945 18.7703 13.7945 18.7518 13.7011 18.714C13.6077 18.6763 13.5228 18.6202 13.4516 18.5489C13.3804 18.4777 13.3243 18.3929 13.2865 18.2995C13.2488 18.2061 13.2303 18.1061 13.2321 18.0054C13.2338 17.9047 13.2559 17.8054 13.2969 17.7134C13.3379 17.6214 13.397 17.5386 13.4707 17.4699L18.1907 12.7499L4.00066 12.7499C3.80175 12.7499 3.61098 12.6709 3.47033 12.5302C3.32968 12.3896 3.25066 12.1988 3.25066 11.9999C3.25066 11.801 3.32968 11.6102 3.47033 11.4696C3.61098 11.3289 3.80175 11.2499 4.00066 11.2499L18.1907 11.2499L13.4707 6.52991C13.397 6.46125 13.3379 6.37845 13.2969 6.28645C13.2559 6.19445 13.2338 6.09514 13.2321 5.99443C13.2303 5.89373 13.2488 5.7937 13.2865 5.70031C13.3243 5.60692 13.3804 5.52209 13.4516 5.45087C13.5228 5.37965 13.6077 5.32351 13.7011 5.28579C13.7945 5.24807 13.8945 5.22954 13.9952 5.23132C14.0959 5.2331 14.1952 5.25514 14.2872 5.29613C14.3792 5.33712 14.462 5.39622 14.5307 5.46991L20.5307 11.4699Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default TestimonialsNew

interface TestimonialCardProps {
    testimonial: {
        name: string
        text: string
        img: string
    }
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
    return (
        <div className='bg-[#F1FAF6] w-full md:w-[calc(50%-12px)] flex-shrink-0 rounded-lg p-5'>
            <div className='flex flex-col items-start justify-between gap-3'>
                <img src="/images/stars.svg" alt="Five Star Ratings" className='h-4 md:h-5 w-auto' />
                <div className='min-h-[88px] md:min-h-[96px] flex items-start'>
                    <p className='text-xs md:text-sm font-medium leading-relaxed'>
                        {testimonial.text}
                    </p>
                </div>
                <div className='flex items-center justify-start gap-3 mt-1'>
                    <img src={testimonial.img} alt={testimonial.name} className='w-9 h-9 rounded-full object-cover' />
                    <h3 className='text-xs md:text-sm font-bold'>{testimonial.name}</h3>
                </div>
            </div>
        </div>
    )
}
